<template>
  <div id="no-sidebar-content">
    <div id="slot-container">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
}
</script>
